<template>
	
  <div class="p-grid nested-grid tab-card">
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(true)" :class="['p-grid', 'p-ai-center', {'gray':!mfCycleRunning}, {'clickable':mfCycleRunning}]">
        <div class="p-col-fixed p-text-center icon">
          <i v-if="mfCycleRunning" :class="['cycle-spinner']"><span :class="cycles.icons[appliance.gamma][appliance.cycle.functionRunning].icon" style="font-size: 35px;"/></i>
        </div>
        <div class="p-col">
          <span v-if="mfCycleRunning">{{$t('mf.phases['+appliance.cycle.phaseRunning+']')}}</span> 
          <span v-else>{{$t('mf.no_cycle_running')}}</span>
        </div>
        <div v-if="mfCycleRunning" class="p-col-fixed p-text-right">
          <span>{{ mfCyclePhaseNumber}}/{{appliance.cycle.cycleTotalPhases}}</span> 
        </div>
        <div class="param-cta">
          <i v-if="mfCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(!mfContinuousCycleRunning)" :class="['p-grid', 'p-ai-center', {'gray':!mfCycleRunning || mfContinuousCycleRunning}, {'clickable':mfCycleRunning && !mfContinuousCycleRunning}]">
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-time"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.mf.remaining_time')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span>{{mfRemainingTime}}</span> 
        </div>
        <div class="param-cta">
          <i v-if="mfCycleRunning && !mfContinuousCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(mfAirSetpointEnabled)" :class="['p-grid', 'p-ai-center', {'gray':!mfCycleRunning || !mfAirSetpointEnabled}, {'clickable':mfCycleRunning && mfAirSetpointEnabled}]">
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-air_temp"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.mf.air_temp')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span v-if="mfCycleRunning && mfAirSetpointEnabled">{{$functions.temperature(mfAirSetpoint, isCelsius)}}{{unit}}</span> 
          <span v-else>-{{unit}}</span>  
        </div>
        <div class="param-cta">
          <i v-if="mfCycleRunning && mfAirSetpointEnabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(mfCoreSetpointEnabled)" :class="['p-grid', 'p-ai-center', {'gray':!mfCycleRunning || !mfCoreSetpointEnabled}, {'clickable':mfCycleRunning && mfCoreSetpointEnabled}]">
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-core_temp"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.mf.core_temp')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span v-if="mfCycleRunning && mfCoreSetpointEnabled">{{$functions.temperature(mfCoreSetpoint,isCelsius)}}{{unit}}</span> 
          <span v-else>-{{unit}}</span>  
        </div>
        <div class="param-cta">
          <i v-if="mfCycleRunning && mfCoreSetpointEnabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(true)" :class="['p-grid', 'p-ai-center', !mfCycleRunning? 'gray':'clickable']">
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-fan"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.mf.fan_level')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <span v-if="mfCycleRunning">{{mfFanLevel}}</span> 
          <span v-else>-</span> 
        </div>
        <div class="param-cta">
          <i v-if="mfCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="onoffDialog" :class="['p-grid', 'p-ai-center', {'gray': onoffDisabled }, {'clickable': !onoffDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <img :class="[{'fade':onoffDisabled}]" src="assets/irinox/icons/onoff.svg" alt="ON/OFF"/>
        </div>
        <div class="p-col">
          <span>{{$t('library.cycle.stop_button')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <img :class="[{'fade':onoffDisabled}]"  v-if="onoffDisabled" src="assets/irinox/icons/switched_off.svg" :alt="$t('library.cycle.stop_button')"/>
          <img :class="[{'fade':onoffDisabled}]" v-else src="assets/irinox/icons/switched_on.svg" :alt="$t('library.cycle.stop_button')"/>
        </div>
        <div class="param-cta"></div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <Sanigen :serialNumber="serialNumber" />
    </div>
  </div>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.mf.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.mf.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.mf.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

  <IrinoxDialogDark :visible="dialog.stop" mode="confirm" 
    :leftB="$t('library.cycle.stop_dialog_cancel_button')" @click:left-button="() => {dialog.stop = false;}" 
    :rightB="$t('library.cycle.stop_dialog_ok_button')" @click:right-button="stopCycle" 
    :message="$t('library.cycle.stop_dialog')"
    icon="assets/irinox/icons/play_big.svg" />
  <IrinoxDialogDark :visible="dialog.stopSuccess" 
    mode="success" 
    :message="$t('library.cycle.stop_dialog_success')"
    :life="3000" 
    @update:visible="dialog.stopSuccess = $event" />

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Sanigen from '../Sanigen.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
import EventHubListenerService from '../../../service/EventHubListenerService';
import commands from "../../../../public/json/commands_mf.json"

export default {
    components: {
      IrinoxDialogDark,
      Sanigen,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          dialog: {
            error: false,
            blockingError: false,
            success: false,
            stop: false,
            stopSuccess: false,
          },
          setpoint: {
            airTemp: null,
            coreTemp: null,
            fan: null,
            humidity: null,
            phaseDuration: null
          },
          commands: commands,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        onoffDisabled: function() {
          return !this.appliance.online || !this.mfCycleRunning;
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        mfCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1 && this.appliance.cycle;
        },
        mfContinuousCycleRunning: function() {
          return !this.appliance.cycle || !this.appliance.cycle.cycleTimeLeft || this.appliance.cycle.cycleTimeLeft<=0;
          // return this.mfCycleRunning && this.appliance.cycle.functionRunning && this.appliance.cycle.functionRunning==13;
        },
        mfAirTemp: function() {
          return this.appliance.status && this.appliance.status.TCell ? this.appliance.status.TCell : null;
        },
        mfCoreTemp: function() {
          return this.appliance.status && this.appliance.status.operativeCoreTemperature ? this.appliance.status.operativeCoreTemperature : null;
        },
        mfIsCore: function() {
          return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        },
        mfRemainingTime: function() {
          if(!this.mfContinuousCycleRunning && !this.mfIsCore) {
            try {
              let time = this.mfCycleRunning && this.appliance.cycle && this.appliance.cycle.cycleTimeLeft ? this.appliance.cycle.cycleTimeLeft / 60 : null;
              //time in minutes
              if(time) {
                var hours = Math.floor(time / 60);
                time = time - hours * 60;
                var minutes = Math.floor(time);
                return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
              }
            } catch(err) {
              return "N/A";
            }
          }
          return "--h:--m";
        },
        mfAirSetpoint: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.cellSetTemp : null;
        },
        mfCoreSetpoint: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.coreProbeSetTemp : null;
        },
        mfAirSetpointEnabled: function() {
          return this.limits.cellSetTempMin!=null && this.limits.cellSetTempMax!=null;
        },
        mfCoreSetpointEnabled: function() {
          return this.limits.coreProbeSetTempMin!=null && this.limits.coreProbeSetTempMax!=null;
        },
        mfFanLevel: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.evapFanSetSpeed : null;
        },
        mfCyclePhaseNumber: function() {
          return this.appliance.cycle.cyclePhaseNumber + 1;
        },
        limits: function() {
          if(this.mfCycleRunning) {
            try {
              let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
              let p = f.phases[String(this.appliance.cycle.phaseRunning)];
              if(p) {
                let lim = this.$functions.clone(p);
                if(lim.cellSetTempMin) {
                  lim.cellSetTempMin*=10;
                }
                if(lim.cellSetTempMax) {
                  lim.cellSetTempMax*=10;
                }
                if(lim.coreProbeSetTempMin) {
                  lim.coreProbeSetTempMin*=10;
                }
                if(lim.coreProbeSetTempMax) {
                  lim.coreProbeSetTempMax*=10;
                }
                return lim;
              }
            } catch(err) {
              console.warn("Error parsing commands " + err);
            }
          }
          return {
              name: null,
              cellSetTempMin: null,
              cellSetTempMax: null,
              coreProbeSetTempMin: null,
              coreProbeSetTempMax: null,
              setLevelHumidityMin: null,
              setLevelHumidityMax: null,
              evapFanSetSpeedMin: null,
              evapFanSetSpeedMax: null,
              phaseDurationSetMin: null,
              phaseDurationSetMax: null
            };
        }
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    methods: {
      parametersDialog(enable) {
        if(!enable || !this.mfCycleRunning) {
          return;
        }
        this.setpoint = {
          airTemp: this.mfAirTemp,
          coreTemp: this.mfCoreTemp,
          fan: this.mfFanLevel,
          humidity: null,
          phaseDuration: null // ???
        };
        if(this.appliance.cycleLibrary) {
          this.$router.push({ name: 'appliance-mf-cycle', params: { serialNumber: this.appliance.serialNumber }});
        } else {
          this.$router.push({ name: 'appliance-mf-cycle-def', params: { serialNumber: this.appliance.serialNumber }});
        }
      },
      // setSetpoint() {
      //   let data = {};
      //   if(this.setpoint.airTemp != null) {
      //     data.cellSetTemp = this.setpoint.airTemp;
      //   }
      //   if(this.setpoint.coreTemp != null) {
      //     data.coreProbeSetTemp = this.setpoint.coreTemp;
      //   }
      //   if(this.setpoint.fan != null) {
      //     data.evapFanSetSpeed = this.setpoint.fan;
      //   }
      //   if(this.setpoint.humidity != null) {
      //     data.setLevelHumidity = this.setpoint.humidity;
      //   }
      //   if(this.setpoint.phaseDuration != null) {
      //     data.phaseDurationSet = this.setpoint.phaseDuration;
      //   }

      //   this.dialog.fan = false;
      //   this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
      //     .then((data) => {
      //       if(data.code=="200") {
      //         this.dialog.success = true;
      //       } else {
      //         console.error("EXCEPTION "+JSON.stringify(data));
      //         this.dialog.error = true;
      //       }
      //     })
      //     .catch(error => {
      //       console.error("EXCEPTION "+error);
      //       this.dialog.error = true;
      //     });

      // }
      onoffDialog() {
        if(this.onoffDisabled || this.readOnlyMode) {
          return;
        }
        this.dialog.stop = true;
      },
      stopCycle() {
        let recipeId = this.appliance.cycle.runningCycleId;
        if(typeof recipeId === "number") {
          recipeId = "IRINOX_" + (recipeId).toString().padStart(8, '0');
        }
        let stopCommand = {
          id: recipeId,
          operationSet: 0
        };
        this.dialog.stop = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, stopCommand)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.stopSuccess = true;
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
    }
}
</script>

<style >

</style>